export default __webpack_public_path__ + "901fd9cadb33637c502f32370a3e6d73.jpg";